import EditInfoImageDialogRouteConnect from './EditInfoImageDialogRouteConnect';
import DeleteImageDialogRouteConnect from './DeleteImageDialogRouteConnect';
import NewFolderDialogRouteConnect from './NewFolderDialogRouteConnect';
import DeleteFolderDialogRouteConnect from './DeleteFolderDialogRouteConnect';
import RenameFolderDialogRouteConnect from './RenameFolderDialogRouteConnect';
import UploadImageFromUrlDialog from 'shared/components/UploadImageFromUrlDialog';
import ErrorImageDialog from './ErrorImageDialog';

export {
  EditInfoImageDialogRouteConnect,
  DeleteImageDialogRouteConnect,
  NewFolderDialogRouteConnect,
  DeleteFolderDialogRouteConnect,
  RenameFolderDialogRouteConnect,
  UploadImageFromUrlDialog,
  ErrorImageDialog,
};
